import React from "react";
import {
  Accordion as ChakraAccordion,
  type AccordionProps as ChakraAccordionProps,
  type SpaceProps,
} from "@chakra-ui/react";
import { type Theme } from "contexts/color-theme";
import { AccordionItem, type AccordionItemProps } from "./accordion-item";

type BaseAccordionProps = {
  /**
   * The color theme of the accordion.
   *
   * @default "light"
   */
  theme?: Theme;
  /**
   * The accordion items
   */
  items: AccordionItemProps[];
};

export type AccordionProps = BaseAccordionProps & Pick<ChakraAccordionProps, "width" | "maxWidth"> & SpaceProps;

export function Accordion({ items, theme = "light", ...props }: AccordionProps) {
  return (
    <ChakraAccordion allowToggle defaultIndex={0} {...props}>
      {items.map((item, index) => (
        <AccordionItem key={item.id ?? item.title} isFirst={index === 0} theme={theme} {...item} />
      ))}
    </ChakraAccordion>
  );
}
